// FAQ (tienda v5) — port de maquetas/tienda-v5-faq.html a JSX.
// Página 8 de Fase 3. Ruta /faq (+ dev alias). Acento TEAL. Página de contenido
// (no depende de productos.js). CSS co-locado bajo .tv5-page-faq.
//
// Reusa shared: TopNav(teal) / Breadcrumb / Footer / BottomNav / MiniBar.
// FaqMini queda corto acá (no tiene secciones ni buscador) → accordion propio.
//
// Buscador React-idiomático: estado controlado `q`, cada <details> con `open`
// controlado (fuerza abierto los que matchean durante la búsqueda; fuera de
// búsqueda respeta el toggle del usuario). El texto de búsqueda se extrae del
// JSX con nodeText() para no duplicar el contenido de las respuestas.
//
// Nota de contenido: la maqueta tenía 6 secciones; acá van 5 (sin la de
// "Descuentos y comunidad" con emoji) — porteros/empresas/vecinos viven en sus
// propias páginas de Fase 3. Sin emojis en los encabezados de sección.
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { TopNav, Breadcrumb, Footer, BottomNav, MiniBar } from '../../components/tienda-v5';
import { TV5_ROUTES, TV5_EXTERNAL } from '../../components/tienda-v5/routes';

// Secciones FAQ (hardcoded — Fase 4 puede migrar a CMS).
const SECCIONES = [
  {
    id: 'empezar',
    titulo: 'Empezar',
    items: [
      {
        q: '¿Qué es Limpack en una línea?',
        a: <>Suscripción mensual de productos de limpieza. Elegís tu kit, llega solo a tu puerta cada mes, envío gratis el día que pasamos por tu barrio.</>,
      },
      {
        q: '¿Cómo empiezo?',
        a: <>Elegís tu kit desde <Link to={TV5_ROUTES.kits}>Kits</Link>, ponés tu dirección, pagás con MercadoPago y te llegamos el próximo día de ruta de tu zona. En 3 minutos ya estás suscripto.</>,
      },
      {
        q: '¿Necesito crear cuenta?',
        a: <>Sí, para poder pausar, cambiar kit o revisar tus entregas desde el panel. La cuenta es gratis y la creás mientras pagás — sin CI, sin datos raros.</>,
      },
      {
        q: '¿Cómo funciona el plan de 3 meses?',
        a: <>El mes 1 pagás precio de compra única (el más alto). Si seguís hasta el mes 3, te descontamos esa diferencia en las facturas 2 y 3 — terminás pagando lo mismo que 3 meses de suscripción. Si cancelás antes del mes 3, la diferencia queda. Después del mes 3 seguís mes a mes.</>,
      },
      {
        q: '¿También puedo comprar suelto sin suscribirme?',
        a: <>Sí, en <Link to={TV5_ROUTES.tienda}>La Tienda</Link>. Sin cuenta, sin ataduras. Si sumás más de $1.000 y caés en el día de ruta de tu barrio, el envío también es gratis.</>,
      },
    ],
  },
  {
    id: 'kits',
    titulo: 'Kits y productos',
    items: [
      {
        q: '¿Cómo elijo mi kit?',
        a: <>Tenemos 6 kits armados según el tamaño de tu hogar y estilo (Essential = lo justo, Premium = con extras). Elegís el que va con vos y podés cambiarlo mes a mes desde tu cuenta.</>,
      },
      {
        q: '¿Puedo cambiar de kit?',
        a: <>Sí, cuantas veces quieras. Desde tu cuenta cambiás para la próxima entrega — hasta las 16 hs del día anterior a la entrega (corte de armado).</>,
      },
      {
        q: '¿Los productos son de marca?',
        a: <>Sí. Trabajamos con productos <b>que probamos nosotros</b>. Te avisamos qué te llega cada mes por WhatsApp y podés cambiar lo que no te sirva.</>,
      },
      {
        q: '¿Puedo pedir productos específicos?',
        a: <>Cambios menores dentro del kit sí (ej. suavizante rosa en lugar de blanco). Marcas específicas no siempre — dependemos del stock del mes. Si algo no te gusta, lo cambiamos por otro equivalente sin cargo.</>,
      },
      {
        q: '¿Y si algo no me gusta?',
        a: <>Nos escribís por WhatsApp y lo cambiamos por otro equivalente en la próxima entrega. Sin drama.</>,
      },
      {
        q: '¿Puedo agregar extras al pedido?',
        a: <>Sí. Desde <Link to={TV5_ROUTES.tienda}>La Tienda</Link> sumás cualquier producto suelto y llega junto con tu kit del mes. <b>Envío gratis si sos suscriptor.</b></>,
      },
    ],
  },
  {
    id: 'envios',
    titulo: 'Envíos y días',
    items: [
      {
        q: '¿A qué zonas llegan?',
        a: <><b>Lunes/Jueves:</b> Pocitos, Villa Biarritz, Punta Carretas, Palermo.<br /><b>Martes:</b> Cordón, Parque Rodó, Parque Batlle.<br /><b>Miércoles/Viernes:</b> Buceo, Malvín, Punta Gorda, Carrasco.<br /><br />Ver el detalle en <Link to={TV5_ROUTES.barrios}>Barrios</Link>. Si tu zona no está cubierta, te avisamos en cuanto lleguemos.</>,
      },
      {
        q: '¿Cuándo llega mi kit?',
        a: <>El día que pasamos por tu barrio, en una franja de 4 horas. Te avisamos por WhatsApp cuando salimos del hub.</>,
      },
      {
        q: '¿Cuánto sale el envío?',
        a: <><b>Si sos suscriptor:</b> gratis siempre que tu entrega caiga en el día de ruta de tu barrio.<br /><br /><b>Si comprás suelto en La Tienda:</b> envío gratis cuando el pedido supera <b>$1.000</b> y caés en el día de ruta. Por debajo, lo coordinamos.<br /><br /><b>Express (otro día):</b> tiene un costo según la distancia. Lo cotizamos por WhatsApp.</>,
      },
      {
        q: '¿Cuándo recibo el primer kit?',
        a: <>Una vez que confirmás la suscripción, te asignamos al <b>próximo día de ruta de tu zona</b>. Te avisamos por WhatsApp el día anterior con la franja horaria.</>,
      },
      {
        q: '¿Qué pasa si no estoy cuando llega?',
        a: <>Si hay portero, lo dejamos con él (previa autorización). Si no, te escribimos por WhatsApp para coordinar reentrega — la primera no tiene recargo.</>,
      },
      {
        q: '¿Puedo cambiar la dirección?',
        a: <>Sí, desde tu cuenta. Si la nueva dirección está en otra zona, se ajusta al día de ruta de ese barrio.</>,
      },
    ],
  },
  {
    id: 'pagos',
    titulo: 'Pagos y facturación',
    items: [
      {
        q: '¿Qué métodos de pago aceptan?',
        a: <>Todo procesado por <b>MercadoPago</b>: tarjetas de crédito y débito (Visa, Mastercard, OCA, AmEx, Cabal), banca digital, Redpagos, Abitab, transferencia y cuotas sin recargo. Cobro automático mensual, datos protegidos con cifrado SSL.</>,
      },
      {
        q: '¿Los precios incluyen IVA?',
        a: <>Sí, todos los precios publicados incluyen IVA.</>,
      },
      {
        q: '¿Emiten factura?',
        a: <>Sí, e-Ticket (o e-Factura si sos empresa con RUT) enviada automáticamente por email después de cada pago. Todos los CFE quedan en tu cuenta y podés descargarlos cuando quieras.</>,
      },
      {
        q: '¿Cuándo me cobran?',
        a: <>El primer cobro sale al confirmar la suscripción. Los siguientes se cobran <b>automáticamente cada 30 días</b> desde tu último pago. Te llega email + WhatsApp de aviso.</>,
      },
      {
        q: '¿Y si el cobro falla?',
        a: <>Reintentamos automáticamente un par de veces más. Si sigue fallando, te avisamos por WhatsApp para coordinar y no cortamos el servicio automáticamente.</>,
      },
    ],
  },
  {
    id: 'cambios',
    titulo: 'Cambios y bajas',
    items: [
      {
        q: '¿Puedo cancelar cuando quiera?',
        a: <>Sí, en cualquier momento por WhatsApp o desde tu cuenta. Lo único: si cancelás antes de completar los primeros 3 meses, perdés la bonificación diferida del mes 1. A partir del mes 4 pausás o cancelás sin nada que perder.</>,
      },
      {
        q: '¿Puedo pausar la suscripción?',
        a: <>Sí, un mes o más. Desde tu cuenta activás una pausa y no te cobramos ni te llega el kit. Retomás cuando quieras, sin volver a suscribirte.</>,
      },
      {
        q: '¿Cómo cancelo?',
        a: <>Desde tu cuenta, con un botón. Sin llamadas, sin formularios raros, sin permanencia. También por WhatsApp si preferís.</>,
      },
      {
        q: '¿Puedo devolver un producto?',
        a: <>Ley 17.250: dentro de los 5 días hábiles de recibido, tenés derecho de revocación. Nos escribís y coordinamos el retiro. Si el producto está dañado o venció, lo cambiamos sin cargo aunque hayan pasado los 5 días.</>,
      },
    ],
  },
];

// Extrae texto plano de un ReactNode (strings, arrays, elementos con children) →
// permite buscar sobre respuestas JSX sin duplicar el contenido como string.
function nodeText(node) {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(nodeText).join('');
  if (node.props && node.props.children != null) return nodeText(node.props.children);
  return '';
}

export default function FAQ() {
  const [q, setQ] = useState('');
  const [abiertas, setAbiertas] = useState({}); // {itemKey: bool} fuera de búsqueda

  // Índice de búsqueda: cada item con su texto plano (pregunta + respuesta) en minúsculas.
  const indexado = useMemo(
    () =>
      SECCIONES.map((sec) => ({
        ...sec,
        items: sec.items.map((it, i) => ({
          ...it,
          key: `${sec.id}-${i}`,
          texto: `${it.q} ${nodeText(it.a)}`.toLowerCase(),
        })),
      })),
    []
  );

  const query = q.trim().toLowerCase();
  const buscando = query.length > 0;

  // Filtrado: por sección, items que matchean; secciones sin match se ocultan.
  const secciones = indexado
    .map((sec) => ({
      ...sec,
      items: buscando ? sec.items.filter((it) => it.texto.includes(query)) : sec.items,
    }))
    .filter((sec) => sec.items.length > 0);

  const totalMatches = buscando ? secciones.reduce((n, s) => n + s.items.length, 0) : 0;

  const countTexto = !buscando
    ? ''
    : totalMatches === 0
    ? '👀 Sin resultados — probá otra palabra'
    : `${totalMatches} resultado${totalMatches > 1 ? 's' : ''}`;

  // Abierto efectivo: en búsqueda todos los matches van abiertos; fuera, respeta el toggle.
  const estaAbierta = (key) => (buscando ? true : !!abiertas[key]);
  const onToggle = (key, open) => setAbiertas((prev) => ({ ...prev, [key]: open }));

  return (
    <div className="tv5-page-faq">
      <style>{FAQ_CSS}</style>

      <TopNav active="faq" accent="teal" />
      <Breadcrumb backHref={TV5_ROUTES.home} backLabel="Home" current="Preguntas frecuentes" />

      <main>
        {/* HERO */}
        <section className="fq-hero">
          <span className="fq-eyebrow">FAQ</span>
          <h1>Preguntas <em>frecuentes.</em></h1>
          <p>Todo lo que te preguntás antes de empezar. Si algo no está acá, escribinos por WhatsApp — te contesta uno de nosotros.</p>
        </section>

        {/* BUSCADOR */}
        <div className="fq-buscador-wrap">
          <span className="fq-buscador-icon" aria-hidden="true">🔍</span>
          <input
            type="text"
            className="fq-buscador"
            placeholder="Buscá una palabra: envío, cancelar, pago..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            aria-label="Buscar en preguntas frecuentes"
          />
          <div className="fq-buscador-count" aria-live="polite">{countTexto}</div>
        </div>

        {/* SECCIONES */}
        <div className="fq-wrap">
          {secciones.map((sec) => (
            <div className="fq-seccion" key={sec.id}>
              <div className="fq-seccion-head">
                <h2>{sec.titulo}</h2>
              </div>
              {sec.items.map((it) => (
                <details
                  className="fq-item"
                  key={it.key}
                  open={estaAbierta(it.key)}
                  onToggle={(e) => onToggle(it.key, e.currentTarget.open)}
                >
                  <summary>{it.q}</summary>
                  <div className="fq-a">{it.a}</div>
                </details>
              ))}
            </div>
          ))}

          {/* CARD "NO ENCONTRASTE?" */}
          <div className="fq-no-encontraste">
            <h3>¿No encontraste lo que buscabas, <em>eh?</em></h3>
            <p>Escribinos por WhatsApp y <b>te contesta uno de nosotros</b>. No un bot. Nada de espera.</p>
            <div className="fq-no-encontraste-btns">
              <a
                href={`${TV5_EXTERNAL.whatsapp}?text=${encodeURIComponent('Hola! Tengo una consulta')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="fq-btn-wa"
              >
                <WaIcon /> Escribinos
              </a>
              <a href={`${TV5_EXTERNAL.mail}?subject=Consulta`} className="fq-btn-mail">✉ hola@limpack.uy</a>
            </div>
          </div>
        </div>
      </main>

      <MiniBar checkoutHref={TV5_ROUTES.checkout} />
      <Footer accent="teal" />
      <BottomNav active="faq" />
    </div>
  );
}

function WaIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

const FAQ_CSS = `
.tv5-page-faq {
  --tv5f-navy:#1A3461; --tv5f-teal:#00A8B5; --tv5f-gold:#C5A059; --tv5f-green:#10B981;
  --tv5f-bg:#0A1424; --tv5f-card:rgba(255,255,255,0.04); --tv5f-border:rgba(255,255,255,0.08);
  --tv5f-text:#F8F6F1; --tv5f-muted:rgba(248,246,241,0.65); --tv5f-dim:rgba(248,246,241,0.45);
  --safe-bottom:env(safe-area-inset-bottom, 0px);
  background:var(--tv5f-bg); color:var(--tv5f-text); min-height:100vh; position:relative;
  overflow-x:clip; max-width:100%;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
  padding-bottom:calc(72px + var(--safe-bottom));
}
.tv5-page-faq::before {
  content:''; position:fixed; inset:0; pointer-events:none; z-index:0;
  background:
    radial-gradient(circle at 20% 10%, rgba(0,168,181,0.10) 0%, transparent 40%),
    radial-gradient(circle at 80% 60%, rgba(197,160,89,0.08) 0%, transparent 40%);
}
.tv5-page-faq main { position:relative; z-index:1; }
@media (min-width:900px){ .tv5-page-faq { padding-bottom:0; } }

/* HERO */
.tv5-page-faq .fq-hero { padding:30px 20px 10px; text-align:center; max-width:900px; margin:0 auto; }
.tv5-page-faq .fq-eyebrow { display:inline-block; color:var(--tv5f-teal); font-size:11px; font-weight:800; letter-spacing:0.15em; text-transform:uppercase; padding:6px 14px; background:rgba(0,168,181,0.1); border:1px solid rgba(0,168,181,0.3); border-radius:999px; margin-bottom:14px; }
.tv5-page-faq .fq-hero h1 { font-size:clamp(28px, 6vw, 46px); font-weight:800; letter-spacing:-0.03em; line-height:1.1; margin-bottom:12px; }
.tv5-page-faq .fq-hero h1 em { color:var(--tv5f-teal); font-style:italic; }
.tv5-page-faq .fq-hero p { font-size:16px; color:var(--tv5f-muted); line-height:1.5; max-width:620px; margin:0 auto; }

/* BUSCADOR */
.tv5-page-faq .fq-buscador-wrap { max-width:720px; margin:24px auto 8px; padding:0 20px; position:relative; }
.tv5-page-faq .fq-buscador { width:100%; padding:16px 20px 16px 54px; background:rgba(255,255,255,0.05); border:1px solid var(--tv5f-border); border-radius:999px; color:var(--tv5f-text); font-family:inherit; font-size:15px; font-weight:500; outline:none; transition:all 0.2s; }
.tv5-page-faq .fq-buscador::placeholder { color:var(--tv5f-dim); }
.tv5-page-faq .fq-buscador:focus { background:rgba(255,255,255,0.08); border-color:rgba(0,168,181,0.5); box-shadow:0 0 0 4px rgba(0,168,181,0.15); }
.tv5-page-faq .fq-buscador-icon { position:absolute; left:40px; top:28px; transform:translateY(-50%); font-size:18px; opacity:0.6; pointer-events:none; }
.tv5-page-faq .fq-buscador-count { text-align:center; font-size:12px; color:var(--tv5f-dim); margin-top:12px; min-height:16px; }

/* SECCIONES */
.tv5-page-faq .fq-wrap { max-width:900px; margin:0 auto; padding:20px 20px 40px; }
.tv5-page-faq .fq-seccion { margin-top:32px; }
.tv5-page-faq .fq-seccion-head { display:flex; align-items:center; gap:12px; margin-bottom:14px; padding-bottom:10px; border-bottom:1px solid var(--tv5f-border); }
.tv5-page-faq .fq-seccion h2 { font-size:18px; font-weight:800; letter-spacing:-0.01em; color:var(--tv5f-text); }

.tv5-page-faq .fq-item { background:var(--tv5f-card); border:1px solid var(--tv5f-border); border-radius:14px; margin-bottom:8px; overflow:hidden; transition:border-color 0.2s, background 0.2s; }
.tv5-page-faq .fq-item[open] { background:rgba(0,168,181,0.06); border-color:rgba(0,168,181,0.25); }
.tv5-page-faq .fq-item summary { padding:16px 20px; font-size:15px; font-weight:700; color:var(--tv5f-text); cursor:pointer; list-style:none; display:flex; align-items:center; justify-content:space-between; gap:12px; transition:color 0.2s; }
.tv5-page-faq .fq-item summary::-webkit-details-marker { display:none; }
.tv5-page-faq .fq-item summary::after { content:'+'; font-size:20px; font-weight:400; color:var(--tv5f-teal); flex-shrink:0; transition:transform 0.2s; }
.tv5-page-faq .fq-item[open] summary::after { transform:rotate(45deg); }
@media (hover:hover){ .tv5-page-faq .fq-item summary:hover { color:var(--tv5f-teal); } }
.tv5-page-faq .fq-a { padding:0 20px 18px; font-size:14px; color:var(--tv5f-muted); line-height:1.6; }
.tv5-page-faq .fq-a b { color:var(--tv5f-text); }
.tv5-page-faq .fq-a a { color:var(--tv5f-teal); text-decoration:none; font-weight:600; }
@media (hover:hover){ .tv5-page-faq .fq-a a:hover { text-decoration:underline; } }

/* CARD "NO ENCONTRASTE?" */
.tv5-page-faq .fq-no-encontraste { max-width:720px; margin:40px auto 0; padding:28px 24px; background:linear-gradient(135deg,rgba(0,168,181,.14) 0%,rgba(26,52,97,.28) 50%,rgba(197,160,89,.10) 100%); border:1px solid rgba(0,168,181,.22); border-radius:22px; backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px); text-align:center; }
.tv5-page-faq .fq-no-encontraste h3 { font-size:20px; font-weight:800; letter-spacing:-0.01em; margin-bottom:10px; }
.tv5-page-faq .fq-no-encontraste h3 em { color:var(--tv5f-teal); font-style:italic; }
.tv5-page-faq .fq-no-encontraste p { font-size:14px; color:var(--tv5f-muted); line-height:1.6; margin-bottom:20px; }
.tv5-page-faq .fq-no-encontraste p b { color:var(--tv5f-text); }
.tv5-page-faq .fq-no-encontraste-btns { display:flex; gap:10px; flex-wrap:wrap; justify-content:center; }
.tv5-page-faq .fq-btn-wa { display:inline-flex; align-items:center; gap:8px; background:#25D366; color:#fff; padding:12px 22px; border-radius:12px; font-weight:800; font-size:14px; text-decoration:none; box-shadow:0 10px 28px rgba(37,211,102,.35); transition:transform .2s; min-height:44px; }
.tv5-page-faq .fq-btn-mail { display:inline-flex; align-items:center; gap:8px; background:rgba(255,255,255,0.06); border:1px solid var(--tv5f-border); color:var(--tv5f-text); padding:12px 22px; border-radius:12px; font-weight:700; font-size:14px; text-decoration:none; transition:all .2s; min-height:44px; }
@media (hover:hover){
  .tv5-page-faq .fq-btn-wa:hover { transform:translateY(-2px); }
  .tv5-page-faq .fq-btn-mail:hover { background:rgba(255,255,255,0.1); border-color:var(--tv5f-teal); color:var(--tv5f-teal); }
}

/* Reduced motion */
@media (prefers-reduced-motion:reduce){
  .tv5-page-faq .fq-item, .tv5-page-faq .fq-item summary, .tv5-page-faq .fq-item summary::after,
  .tv5-page-faq .fq-btn-wa, .tv5-page-faq .fq-btn-mail, .tv5-page-faq .fq-buscador { transition:none; }
}
`;
